import { render } from "./insurance-company-list.vue?vue&type=template&id=620d5dfc"
import script from "./insurance-company-list.vue?vue&type=script&lang=js"
export * from "./insurance-company-list.vue?vue&type=script&lang=js"

import "./insurance-company-list.vue?vue&type=style&index=0&id=620d5dfc&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__